import ContactForm from "../../components/ContactForm";

const ContactMe = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default ContactMe;
